import { ArticleHeading4, ArticleParagraph2 } from '@cian/ui-kit';
import { IconActionArrowUpRight16 } from '@cian/ui-kit-design-tokens/icons';
import { CollapsedList } from '../CollapsedList';
import { Link } from '../Link';
import { ToggleButton } from '../ToggleButton';
import { UIText2 } from '@cian/ui-kit/typography';
import * as styles from './styles.css';
import { IAvailableJks } from '../../types/newbuilding/promoInfo';

interface IAvailableNewbuildingListProps {
  isCollapsed: boolean;
  availableNewbuildingList: IAvailableJks[];
  onToggleClick(): void;
}

export function AvailableNewbuildingList({
  isCollapsed,
  availableNewbuildingList,
  onToggleClick,
}: IAvailableNewbuildingListProps) {
  const visibleJksLength = isCollapsed ? availableNewbuildingList.length : availableNewbuildingList.slice(0, 2).length;
  const hiddenJksLength = availableNewbuildingList.length - visibleJksLength;
  const shouldShowButton = availableNewbuildingList.length - 2 > 0;

  const toggleButtonText = isCollapsed ? 'Свернуть' : `Показать ещё ${hiddenJksLength} ЖК`;

  return (
    <>
      <ArticleHeading4>Акция проходит так же в ЖК:</ArticleHeading4>
      <CollapsedList isOpened={isCollapsed} visibleRows={2} containerStyles={styles['list-collapse']}>
        {availableNewbuildingList.map(availableNewbuildingListItem => (
          <div key={availableNewbuildingListItem.id} className={styles['list-item']}>
            <ArticleParagraph2>{availableNewbuildingListItem.name}</ArticleParagraph2>
            <Link url={availableNewbuildingListItem.link} target={'_blank'}>
              <IconActionArrowUpRight16 color={'icon-main-default'} />
            </Link>
          </div>
        ))}
      </CollapsedList>
      {shouldShowButton && (
        <ToggleButton isOpened={isCollapsed} onClick={onToggleClick}>
          <UIText2 color={'text-main-default'}>{toggleButtonText}</UIText2>
        </ToggleButton>
      )}
    </>
  );
}
